module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-21.ad457067.svg";